import { render, staticRenderFns } from "./KnImagesGalleryItem.vue?vue&type=template&id=0db2de44&"
import script from "./KnImagesGalleryItem.vue?vue&type=script&lang=js&"
export * from "./KnImagesGalleryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports